import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getTelemetry} from './getTelemetry';

export const telemetryQueryOptions = (days: number) =>
  queryOptions({queryKey: keys.system.telemetry(days), queryFn: () => getTelemetry(days)});
